/*
  -*- coding: utf-8 -*-

  This file is part of REANA.
  Copyright (C) 2024 CERN.

  REANA is free software; you can redistribute it and/or modify it
  under the terms of the MIT License; see LICENSE file for more details.
*/

import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";

import { restartWorkflow, closeRestartWorkflowModal } from "~/actions";
import {
  getWorkflowRestartModalOpen,
  getWorkflowRestartModalItem,
} from "~/selectors";

export default function WorkflowRestartModal() {
  const dispatch = useDispatch();
  const open = useSelector(getWorkflowRestartModalOpen);
  const workflow = useSelector(getWorkflowRestartModalItem);

  if (!workflow) return null;

  const onCloseModal = () => {
    dispatch(closeRestartWorkflowModal());
  };

  const { id, name, run } = workflow;
  return (
    <Modal open={open} onClose={onCloseModal} closeIcon size="small">
      <Modal.Header>Restart workflow</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to restart the workflow "{name} #{run}"?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          onClick={() => {
            dispatch(restartWorkflow(id)).then(onCloseModal);
          }}
        >
          Restart
        </Button>
        <Button onClick={onCloseModal}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
}
